import { useState,useEffect } from "react";
import { ManageAddressImage } from "../assets/Order";
import AddressModal from "../modal/addressModal";
import { useNavigate } from "react-router-dom";
import { MdDelete, MdKeyboardBackspace } from "react-icons/md";
import { useDispatch, useSelector } from "react-redux";
import { fetchCustomerAddress } from "../redux/actions/customerAddress";
import { FaPen } from "react-icons/fa";
import DeleteAddressModel from "../modal/deleteAddressModel";

export default function ManageAddress()
{
    const [open, setOpen] = useState(false);
    const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
    const dispatch=useDispatch();
    const [loading, setLoading] = useState(false);
    const navigate=useNavigate();
    const { address, error } = useSelector(
        (state) => state.customerAddressState
    );

    const [selectedAddress, setSelectedAddress] = useState(null);
    const [selectedId,setSelectedId]=useState(null);

useEffect(() => {
  if (address.length > 0) {
    setSelectedAddress(address[0]);
  }
}, [address]);

useEffect(() => {
  const fetchData = async () => {
    try {
      setLoading(true);
      dispatch(fetchCustomerAddress()); 
    } finally {
      setLoading(false);
    }
  };

  fetchData();
}, [dispatch]);

  if (loading) {
  return <p className="text-center mt-10">Loading Address...</p>;
  }

  if(error)
  {
    return(
      <p className="text-red-600">{error}</p>
    );
  }

    return(
        <section className="py-5 px-4 md:px-8 xl:px-10 bg-gray-100">
            <div className="flex flex-row space-x-2 items-center justify-start mb-5" onClick={()=>navigate(-1)}>
                <MdKeyboardBackspace className="text-lg md:text-xl xl:text-2xl" />
                <p className="text-lg md:text-xl xl:text-2xl font-medium text-center pb-2">Manage Address</p>
            </div>

            <div className="flex flex-col md:flex-row  items-center justify-between gap-5 md:gap-8">
                <div className="bg-white rounded-md shadow-md w-full md:w-2/3 p-3 md:p-5">
                    <p className="text-sm md:text-base xl:text-lg font-medium pb-2">Saved Address</p>
                    <div className="border border-gray-500 rounded p-3 md:p-4 space-y-3 text-xs md:text-sm xl:text-base">
                    {address.length===0?(
                        <p className="text-center col-span-full text-red-600 font-semibold py-8">
                            No Address add yet.
                        </p>
                    ) : (
                    address.map((address, index) => (
                        <label key={index} className="flex flex-row items-start space-x-4">
                        <input
                            type="radio"
                            name="delivery"
                            checked={selectedAddress === address}
                            onChange={() => setSelectedAddress(address)}
                            className="accent-[#A63F40]"
                        />
                        <span className="break-words">
                            {`${address.buildingBlock.toUpperCase()} - ${address.flatNo}, ${address.buildingName}, ${address.landmark||""}, ${address.streetName||""}, ${address.city}, ${address.state}, ${address.pincode}`}
                        </span>

                        <div className="flex flex-row space-x-2 items-center justify-end">
                            <button 
                             onClick={() => {setOpen(true);setSelectedId(address.id)}}
                                >
                                <FaPen className="text-sm xl:text-base text-blue-600 " />
                            </button>
                            <button 
                             onClick={() => {setIsDeleteModalOpen(true);setSelectedId(address.id)}}
                            >
                                <MdDelete className="text-lg xl:text-xl text-red-600 " />
                            </button>
                        </div>
                        

                        </label>
                    ))
                    )}
                    <div className="flex justify-center">
                        <button className="mt-4 text-[#A63F40] px-5 py-2 border border-[#A63F40] rounded-md text-xs md:text-sm xl:text-base"
                        onClick={() => setOpen(true)}>+ Add New Address</button>
                    </div>
                    </div>
                </div>
                <div className="w-full md:w-1/3 p-3 md:p-5 flex justify-center">
                    <img src={ManageAddressImage} alt={"address"} className="h-52 md:h-56 xl:h-64"/>
                </div>
            </div>
        <AddressModal isOpen={open} onClose={() => setOpen(false)} id={selectedId}/>
        <DeleteAddressModel isOpen={isDeleteModalOpen} onClose={() => setIsDeleteModalOpen(false)} id={selectedId}/>
        </section>
    );
}